import { Navigate, Routes, Route } from 'react-router-dom';
import AuthCallbackPage from '@/pages/auth/callback/page';
import OnboardingPage from '@/pages/onboarding/page';
import SettingsPage from '@/pages/settings/page';
import MeaningPage from '@/pages/meaning/page';
import VideosPage from '@/pages/videos/page';
import TrainingPage from '@/pages/training/page';
import { ProtectedRoute } from '@/components/ProtectedRoute';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/meaning" replace />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/meaning" element={
        <ProtectedRoute>
          <MeaningPage />
        </ProtectedRoute>
      } />
      <Route path="/meaning/:wordSlug" element={
        <ProtectedRoute>
          <MeaningPage />
        </ProtectedRoute>
      } />
      <Route path="/meaning/card/:meaningId" element={
        <ProtectedRoute>
          <MeaningPage />
        </ProtectedRoute>
      } />
      <Route path="/videos" element={
        <ProtectedRoute>
          <VideosPage />
        </ProtectedRoute>
      } />
      <Route path="/training" element={
        <ProtectedRoute>
          <TrainingPage />
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute>
          <SettingsPage />
        </ProtectedRoute>
      } />
    </Routes>
  );
}
